import React, { Component, PropTypes } from 'react';
import moment from 'moment';

class Feed extends Component {
  render() {
    const {
      item
    } = this.props;

    return (
      <a href={`//omni-feedback.aws-origin.xfinity.com/topic/${item.slug}`} className={`community-feed__item`}>
        <div className="community-feed-post">
          <div className="community-feed-user">
            {item.user.picture &&
              <img className="community-feed-user-picture" src={`//omni-feedback.aws-origin.xfinity.com${item.user.picture}`} />
            }
            {!item.user.picture &&
              <div className="community-feed-user-icon" style={{'backgroundColor': item.user['icon:bgColor']}}>
                {item.user['icon:text']}
              </div>
            }
          </div>
          <div className="community-feed-title community-feed-post-content">
            <span className="x-body2">{item.title}</span>
          </div>
          <div className="community-feed-date community-feed-post-content">
            <span className="x-body2">{moment(item.timestampISO).format('YYYY[-]MM[-]DD')}</span>
          </div>
        </div>
      </a>
    );
  }
}

Feed.propTypes = {
  item: PropTypes.object
};

export default Feed;



/** WEBPACK FOOTER **
 ** ./client/components/Omni/OmniSales/FeedItem.jsx
 **/